import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { useAppDispatch, useAppSelector } from '../hooks'
import { editCurrentVocabulary, setFocus } from '../Store/VocabulariesSlice' // Assuming this action exists
import { useTranslation } from 'react-i18next'

interface WriteOutLinkProps {
  source: string;
  target: string;
}

function WriteOutLink({ source, target }: WriteOutLinkProps) {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const currentVocabularyId = useAppSelector((state) => state.vocabularies.currentVocabulary)
  const rows = useAppSelector((state) => state.vocabularies.currentVocabulary?.rows || [])
  const lastFocusedRow = useAppSelector((state) => state.vocabularies.lastFocusedRow)

  const handleClick = async () => {
    if (!currentVocabularyId || !source) return

    const focusedRow = rows[lastFocusedRow]

    // if empty row, update instead of add
    if (focusedRow && focusedRow.left === '' && focusedRow.right === '') {
      dispatch(editCurrentVocabulary({
        operation: 'updateRow',
        data: {
          position: lastFocusedRow,
          row: {
            ...focusedRow,
            left: source,
            right: target,
          }
        },
      }))
      return
    }

    await dispatch(editCurrentVocabulary({
      operation: 'addRow',
      data: {
        position: lastFocusedRow,
        left: source,
        right: target,
      },
    }))
    dispatch(setFocus({ index: lastFocusedRow + 1 }))
  }

  return (
    <Tooltip title={t('Add to current vocabulary')}>
      <IconButton
        size="small"
        onClick={handleClick}
        sx={{
          padding: '2px',
          color: 'var(--primary-color, #1976d2)',
          marginBottom: '3px',
          marginRight: '10px',
        }}
      >
        <AddCircleOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}

export default WriteOutLink